var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "upload-box" },
    [
      _c(
        "div",
        { staticClass: "avatar-uploader-box" },
        [
          _vm._l(_vm.videoList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "video-preview",
                on: {
                  mouseover: function ($event) {
                    $event.stopPropagation()
                    _vm.isShowPopup = true
                  },
                },
              },
              [
                _c(
                  "video",
                  { staticClass: "avatar", attrs: { src: item.url } },
                  [_vm._v(" 您的浏览器不支持视频播放 ")]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.url && _vm.isShowPopup,
                        expression: "item.url && isShowPopup",
                      },
                    ],
                    staticClass: "avatar-uploader-popup",
                    on: {
                      mouseleave: function ($event) {
                        _vm.isShowPopup = false
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-video-play",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function ($event) {
                          return _vm.previewVideo(item)
                        },
                      },
                    }),
                    _c("i", {
                      staticClass: "el-icon-delete",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function ($event) {
                          return _vm.deleteVideo(item, index)
                        },
                      },
                    }),
                  ]
                ),
              ]
            )
          }),
          _c(
            "el-upload",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.uploadShow,
                  expression: "uploadShow",
                },
              ],
              ref: "avatarUploader",
              staticClass: "avatar-uploader el-upload--picture-card",
              attrs: {
                action: _vm.actionUrl,
                "auto-upload": false,
                "on-change": _vm.handleAvatarChange,
                "show-file-list": false,
              },
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { display: "block" },
                  attrs: {
                    "element-loading-background": "rgba(0, 0, 0, 0.8)",
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-text": "上传中",
                  },
                },
                [_c("i", { staticClass: "el-icon-plus avatar-uploader-icon" })]
              ),
            ]
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "append-to-body": "",
            center: "",
            title: "视频查看",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "video",
            {
              ref: "video",
              staticStyle: { height: "7rem" },
              attrs: {
                src: _vm.videoSrc,
                controls: "",
                alt: "",
                width: "100%",
                height: "50%",
              },
            },
            [_vm._v("您的浏览器不支持视频播放")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }